const actions = {
    GET_PROVEEDORES_REQUEST: 'GET_PROVEEDORES_REQUEST',
    CREATE_PROVEEDOR_REQUEST: 'CREATE_PROVEEDOR_REQUEST',
    EDIT_PROVEEDOR_REQUEST: 'EDIT_PROVEEDOR_REQUEST',
    DELETE_PROVEEDOR_REQUEST: 'DELETE_PROVEEDOR_REQUEST',

    GET_PROVEEDORES_SUCCESS: 'GET_PROVEEDORES_SUCCESS',
    CREATE_PROVEEDOR_SUCCESS: 'CREATE_PROVEEDOR_SUCCESS',
    EDIT_PROVEEDORES_SUCCESS: 'EDIT_PROVEEDORES_SUCCESS',
    DELETE_PROVEEDORES_SUCCESS: 'DELETE_PROVEEDORES_SUCCESS',

    SET_CURRENT_PROVEEDOR: 'SET_CURRENT_PROVEEDOR',
    CLEAR_CURRENT_PROVEEDOR: 'CLEAR_CURRENT_PROVEEDOR',

    initDataProveedores: () => ({ type: actions.GET_PROVEEDORES_REQUEST }),
    createUser: data => ({
        type: actions.CREATE_PROVEEDOR_REQUEST,
        payload: data
    }),
    editUser: data => ({
        type: actions.EDIT_PROVEEDOR_REQUEST,
        payload: data
    }),
    deleteUser: id => ({
        type: actions.DELETE_PROVEEDOR_REQUEST,
        payload: id
    }),
    setCurrentUser: data => ({
        type: actions.SET_CURRENT_PROVEEDOR,
        payload: data
    }),
    clearCurrentUser: () => ({
        type: actions.CLEAR_CURRENT_PROVEEDOR,
    }),

};
export default actions;